module.exports = __webpack_public_path__ + "assets/img/37_1478_big.43aa6c3d.jpg";